import { AddonSettings } from '@ancon/wildcat-types'

import isAddonGroupRequired from './isAddonGroupRequired'

/**
 * The indexes of the add-on groups in the order they are shown:
 * required groups first, otherwise as configured. Form fields keep using
 * the original index.
 */
export default function getAddonGroupDisplayOrder(
  addonGroups: Array<{ addOnSettings: AddonSettings }>,
): number[] {
  const indexes = addonGroups.map((_, index) => index)

  return [
    ...indexes.filter(i => isAddonGroupRequired(addonGroups[i].addOnSettings)),
    ...indexes.filter(i => !isAddonGroupRequired(addonGroups[i].addOnSettings)),
  ]
}
